import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";

@Component({
	selector: "app-about-me-payment-methods",
	templateUrl: "./about-me-payment-methods.component.html",
	styleUrls: ["../../../customer.scss"],
})
export class AboutMePaymentMethodsComponent implements OnInit {
	constructor(public app: AppService, public customerService: CustomerService) {}

	ngOnInit(): void {
		this.customerService.publicCustomer.subscribe((customer) => {
			customer.tokens?.forEach((token) => {
				token.typeDisplayObject = this.app.references.creditCardTypeToDisplayObject(token.type);
			});
		});
	}
}
